(ns ductile.ui.billing
  (:require [clojure.string :as str]
            [ductile.time.format :as time.format]
            [ductile.ui.components :as ui]
            [ductile.ui.components.combobox :as combobox]
            [ductile.ui.deframe :as deframe]
            [ductile.ui.icons :as icons]
            [ductile.ui.locale :as locale :refer [tr]]
            [ductile.ui.router :as router]
            [ductile.ui.scene :as scene]
            [ductile.ui.scope]
            [ductile.ui.util :as util]
            [ductile.ui.workflow :as workflow]
            [inside-out.forms :as forms]
            [inside-out.reagent :refer [with-form]]
            [nextjournal.clerk.render :as render]
            [nextjournal.clerk.viewer :as viewer]
            [nextjournal.view :as v]
            [reagent.core :as r])
  (:require-macros [ductile.ui.scene.macros :refer [defscene]]
                   [ductile.ui.scope.macros :refer [when-current-user-scope]]))

(def link :a.underline.text-blue-500)

(v/defview vehicle-fahrzeug [this]
  [:section
   [:h2 "Vehicle fahrzeug"]])

(v/defview fahrzeuge-table
  "Component which renders a list of fahrzeuge

   The main point here is that this component is unaware of any state
   management, it only relies on standard function calls over sequences and
   maps."
  [this fahrzeuge]
  [ui/data-table
   [:thead [:tr
            [:th "VIN"]
            [:th "Make"]
            [:th "Model"]
            [:th "Customer"]]]
   (into [:tbody]
         (map
          (fn [{:operations.fahrzeug/keys [customer vehicle contract] :as x}]
            [:tr
             [:td (get-in vehicle [:core.vehicle/vin])]
             [:td (get-in vehicle [:core.vehicle/model :vehicle.model/make :vehicle.make/name])]
             [:td (get-in vehicle [:core.vehicle/model :vehicle.model/name])]
             [:td (get-in customer [:core.customer/code])]])
          fahrzeuge))])

;; Additional fields which you can ignore for now:
;; type
;; finalized?
;; issuer
;; recipient
;; language
;; reverse-charge?



(defn rand-date-str []
  (str (rand-nth (range 1 31)) "." 6 ".2021, " (rand-nth (range 1 16)) ":0" (rand-nth (range 1 10))))

(defn filter-group []
  [:div.shadow.overflow-hidden.border-b.border-gray-200.sm:rounded-sm.bg-white.mr-5
   {:style {:width 250 :height 400}}
   [:div.bg-gray-50.py-3.px-6.text-left.text-xs.font-medium.text-gray-500.uppercase.tracking-wider.border-b.border-gray-200
    "Filter"]
   [:div.py-3.px-6
    [:div
     [:label.block.text-sm.font-medium.text-gray-700
      "Abrechnungsart"]
     [:select.mt-1.block.w-full.pl-3.pr-10.py-1.text-sm.border-gray-300.focus:outline-none.focus:ring-indigo-500.focus:border-indigo-500.sm:text-sm.rounded-sm
      [:option "Alle"]
      [:option {:selected "selected"} "nicht abgerechnet"]
      [:option "abgerechnet"]]]
    [:div.mt-3
     [:label.block.text-sm.font-medium.text-gray-700
      "Zeitaum"]
     [:select.mt-1.block.w-full.pl-3.pr-10.py-1.text-sm.border-gray-300.focus:outline-none.focus:ring-indigo-500.focus:border-indigo-500.sm:text-sm.rounded-sm
      [:option {:selected "selected"} "egal"]
      [:option "Zeitraum auswählen"]]]
    [:div.mt-3
     [:label.block.text-sm.font-medium.text-gray-700
      "Kunde"]
     [:select.mt-1.block.w-full.pl-3.pr-10.py-1.text-sm.border-gray-300.focus:outline-none.focus:ring-indigo-500.focus:border-indigo-500.sm:text-sm.rounded-sm
      [:option {:selected "selected"} "Alle"]
      [:option "BMW"]]]
    [:div.mt-3
     [:label.block.text-sm.font-medium.text-gray-700
      "Dienstleistung"]
     [:select.mt-1.block.w-full.pl-3.pr-10.py-1.text-sm.border-gray-300.focus:outline-none.focus:ring-indigo-500.focus:border-indigo-500.sm:text-sm.rounded-sm
      [:option "Alle"]
      [:option {:selected "selected"} "Transport"]
      [:option "Batterieladung"]]]
    [:div.mt-3
     [:label.block.text-sm.font-medium.text-gray-700
      "Strecke"]
     [:select.mt-1.block.w-full.pl-3.pr-10.py-1.text-sm.border-gray-300.focus:outline-none.focus:ring-indigo-500.focus:border-indigo-500.sm:text-sm.rounded-sm
      [:option "Alle"]
      [:option {:selected "selected"} "München – Krefeld"]]]]])

(defn billings-table []
  (let [max-height "calc(100vh - 100px)"
        billable-entries (repeatedly 10 (fn []
                                          (let [status :complete/billable]
                                            {:type "transport"
                                             :from "München"
                                             :to "Krefeld"
                                             :customer "BMW"
                                             :date (rand-date-str)
                                             :status status
                                             :checked? true})))
        not-billable-entries (apply conj [] {:type "transport"
                                             :from "München"
                                             :to "Krefeld"
                                             :customer "BMW"
                                             :date (rand-date-str)
                                             :status :incomplete/unbillable
                                             :checked? false
                                             :selected? true}
                                    (repeatedly 15 (fn []
                                                     (let [status :incomplete/unbillable]
                                                       {:type "transport"
                                                        :from "München"
                                                        :to "Krefeld"
                                                        :customer "BMW"
                                                        :date (rand-date-str)
                                                        :status status
                                                        :checked? false
                                                        :selected? false}))))]
    [:div.border.bg-gray-200.relative
     [:div.flex.bg-white.border-b.justify-between.py-3.px-5.border-b.shadow-md.items-center
      [:h1.font-bold.text-lg "Rechnungsbildung"]
      [:div.relative
       [:div.pointer-events-none.absolute.inset-y-0.left-0.pl-3.flex.items-center
        [:svg.h-5.w-5.text-gray-400
         {:aria-hidden "true", :fill "currentColor", :viewbox "0 0 20 20"}
         [:path
          {:clip-rule "evenodd",
           :d
           "M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z",
           :fill-rule "evenodd"}]]]
       [:input
        {:placeholder "Suche"
         :class "max-w-lg block w-full bg-white border border-gray-300 rounded-md py-2 pl-10 pr-3 text-sm placeholder-gray-500 focus:outline-none focus:text-gray-900 focus:placeholder-gray-400 focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"}]]]
     [:div.p-5
      [:div.flex
       [filter-group]
       [:div.flex-auto
        [:div.flex.mb-10
         [:div.border.border-gray-300.shadow.bg-gray-50.flex-auto.mr-5
          [:div.bg-gray-50.py-3.px-6.text-left.text-xs.font-bold.text-gray-500.uppercase.tracking-wider.border-b.border-gray-300 (str (count not-billable-entries) " nicht abrechenbar dienstleistungen")]
          [:div.flex.flex-col.flex-auto.overflow-y-auto
           {:style {:height 670}}
           [:div.-my-2.overflow-x-auto.sm:-mx-6.lg:-mx-8
            [:div.py-2.align-middle.inline-block.min-w-full.sm:px-6.lg:px-8
             [:div.shadow.overflow-hidden.border-b.border-gray-200.sm:rounded-sm
              [:table.min-w-full.divide-y.divide-gray-200
               [:thead.bg-gray-50
                [:tr
                 [:th.py-3.px-6.text-left.text-xs.font-medium.text-gray-500.uppercase.tracking-wider
                  {:scope "col"}
                  "Beschreibung"]
                 [:th.py-3.text-left.text-xs.font-medium.text-gray-500.uppercase.tracking-wider
                  {:scope "col"}
                  "Kunde"]
                 [:th.px-6.py-3.text-left.text-xs.font-medium.text-gray-500.uppercase.tracking-wider
                  {:scope "col"}
                  "durchgeführt"]]]
               (into [:tbody.bg-white.divide-y.divide-gray-200.text-sm]
                     (map (fn [{:keys [from to date customer selected?]}]
                            [:tr.hover:bg-gray-50.cursor-pointer
                             {:class (when selected? "bg-indigo-50")}
                             [:td.py-4.px-6.whitespace-nowrap
                              "Transport von " [:span.font-bold from] " nach " [:span.font-bold to]]
                             [:td.py-4.whitespace-nowrap
                              customer]
                             [:td.px-6.py-4.whitespace-nowrap.text-sm.text-gray-500
                              date]])
                          not-billable-entries))]]]]]]
         [:div
          {:style {:width 250}}
          [:div.bg-gray-50.py-3.px-6.text-left.text-xs.font-bold.text-gray-500.uppercase.tracking-wider.border-b.border-gray-300
           "Fehlerdetails"]
          [:div.bg-gray-50.text-red-500.px-6.py-3.text-sm.flex.flex-wrap.font-bold
           [:div.rounded-md.border.border-red-400.px-2.py-1.my-2 "Stammdaten fehlen"]
           [:div.rounded-md.border.border-red-400.px-2.py-1.my-2 "Transportdaten nicht vollständig"]
           [:div.rounded-md.border.border-red-400.px-2.py-1.my-2 "Preis für bestimmte Fahrzeugmodelle fehlt"]]]]
        [:div.border.border-gray-300.shadow.bg-gray-50
         [:div.flex.justify-between.items-center.border-b.border-gray-300.bg-gray-50
          [:div.bg-gray-50.py-3.px-6.text-left.text-xs.font-bold.text-gray-500.uppercase.tracking-wider (str (count billable-entries) " Abrechenbar Dienstleistungen")]]
         [:div.flex.flex-col.flex-auto.overflow-y-auto
          {:style {:height 300}}
          [:div.-my-2.overflow-x-auto.sm:-mx-6.lg:-mx-8
           [:div.py-2.align-middle.inline-block.min-w-full.sm:px-6.lg:px-8
            [:div.shadow.overflow-hidden.border-b.border-gray-200.sm:rounded-sm
             [:table.min-w-full.divide-y.divide-gray-200
              [:thead.bg-gray-50
               [:tr
                [:th.px-6.py-3.text-left.text-xs.font-medium.text-gray-500.uppercase.tracking-wider
                 {:scope "col" :style {:width 40}}
                 [:input {:checked true :type "checkbox" :class "h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"}]]
                [:th.py-3.text-left.text-xs.font-medium.text-gray-500.uppercase.tracking-wider
                 {:scope "col"}
                 "Beschreibung"]
                [:th.py-3.text-left.text-xs.font-medium.text-gray-500.uppercase.tracking-wider
                 {:scope "col"}
                 "Kunde"]
                [:th.px-6.py-3.text-left.text-xs.font-medium.text-gray-500.uppercase.tracking-wider
                 {:scope "col"}
                 "durchgeführt"]]]
              (into [:tbody.bg-white.divide-y.divide-gray-200.text-sm]
                    (map (fn [{:keys [from to date customer checked?]}]
                           [:tr
                            {:class (when checked? "bg-indigo-50")}
                            [:td.px-6.py-4.whitespace-nowrap
                             [:input {:checked checked? :type "checkbox" :class "h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"}]]
                            [:td.py-4.whitespace-nowrap
                             "Transport von " [:span.font-bold from] " nach " [:span.font-bold to]]
                            [:td.py-4.whitespace-nowrap
                             customer]
                            [:td.px-6.py-4.whitespace-nowrap.text-sm.text-gray-500
                             date]])
                         billable-entries))]]]]]
         [:div.p-3.bg-indigo-50.border-t.flex
          {:style {:box-shadow "0 -3px 7px rgba(0,0,0,.1)"}}
          [:button
           {:class "flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"}
           "Rechnung erstellen →"]]]]]]]))

(defscene list-billings
  [billings-table])

(defn render-billing-error [error]
  [:div.bg-white.md:rounded-lg.max-w-4xl.mx-auto.mt-4.md:my-6.shadow-lg.justify-center
   [:div
    [ui/flash-notice {:type :error :message [:div
                                             [:div.font-bold (tr "Invoice could not be generated")]
                                             [:div.mt-2
                                              [:ul.list-disc.pl-5.space-y-1
                                               [:li (tr (str (:message error)))]]]]
                      :on-close #(.preventDefault %)}]]])

(defn render-cancellation-error [error]
  [:div.bg-white.md:rounded-lg.max-w-4xl.mx-auto.mt-4.md:my-6.shadow-lg.justify-center
   [:div
    [ui/flash-notice {:type :error :message [:div
                                             [:div.font-bold (tr "Invoice could not be cancelled")]
                                             [:div.mt-2
                                              [:ul.list-disc.pl-5.space-y-1
                                               [:li (tr (str (:message error)))]]]]
                      :on-close #(.preventDefault %)}]]])



(defn render-billing-success [saved-invoice-id billing-warning]
  [:div.bg-white.md:rounded-lg.max-w-4xl.mx-auto.mt-4.md:my-6.shadow-lg.justify-center
   [:div
    [ui/flash-notice {:type (if billing-warning :attention :success)
                      :message [:div
                                [:div.font-bold (tr "Invoice has been generated and saved")]
                                [:div.mt-2
                                 [:ul.list-disc.pl-5.space-y-1
                                  [:li
                                   [:a {:href (str "/invoice/" saved-invoice-id)} (str (tr "Invoice number") ": " saved-invoice-id)]]
                                  (when billing-warning
                                    [ui/tooltip {:content (:error billing-warning)}
                                     [:li [:div.text-red-500 (str "⚠️ " (:message billing-warning) " ⚠️")]]])]]]



                      :on-close #(.preventDefault %)}]]])


(defn render-cancellation-success [credit-note-invoice-id billing-warning]
  [:div.bg-white.md:rounded-lg.max-w-4xl.mx-auto.mt-4.md:my-6.shadow-lg.justify-center
   [:div
    [ui/flash-notice {:type (if billing-warning :attention :success)
                      :message [:div
                                [:div.font-bold (tr "Invoice has been canceled and credit note was created.")]
                                [:div.mt-2
                                 [:ul.list-disc.pl-5.space-y-1
                                  [:li
                                   [:a {:href (str "/invoice/" credit-note-invoice-id)} (str (tr "Credit note invoice number") ": " credit-note-invoice-id)]]
                                  (when billing-warning
                                    [ui/tooltip {:content (:error billing-warning)}
                                     [:li [:div.text-red-500 (str "⚠️ " (:message billing-warning) " ⚠️")]]])]]]



                      :on-close #(.preventDefault %)}]]])


(defn export-link [{:as form :keys [template-id invoice-number]} export-type]
  (str "billing/" (if (or template-id invoice-number) "export" "bulk-export") "?"
       (util/map->url-encoded-query-params (-> form
                                               (update :template-id #(when % (pr-str %)))
                                               (update :contract-ids #(when % (pr-str %)))
                                               (update :compound-names #(when % (pr-str %)))
                                               (dissoc :file-upload)
                                               (assoc :export-type export-type)))))


(defn set-default-accounting-year-month
  "Sets the accounting year month depending on the deadline, usually the 20th of the month"
  [accounting-deadline-day]
  (let [current-date (js/Date.)
        current-day (.getDate current-date)
        _ (when (< current-day accounting-deadline-day)
            (.setMonth current-date (- (.getMonth current-date) 1)))
        current-month (+ 1 (.getMonth current-date))
        current-year (.getFullYear current-date)
        current-month (if (<= 10 current-month) (str current-month) (str "0" current-month))]
    (str current-year "-" current-month)))


(defn addresses-details [title addresses]
  (if (< 1 (count addresses))
    (concat [(str title ": ") [:br]]
            (mapcat (fn [a]
                      [a [:br]]) addresses))
    (str title ": " (str/join ", " addresses))))

(defn email-sending-details [{:keys [to cc bcc attachment-types] :as foo}]
  [:div.text-left.p-4.whitespace-nowrap.text-sm
   (into [:div.font-bold.text-xs.break-all] (addresses-details "An" to))
   (when (seq cc)
     (into [:div.font-medium.text-gray-500.text-xs.flex.break-all.mt-2] (addresses-details "CC" cc)))
   (when (seq bcc)
     (into [:div.font-medium.text-gray-500.text-xs.flex.break-all.mt-2] (addresses-details "BCC" bcc)))
   [:div.font-medium.text-gray-500.text-xs.flex.mt-2
    (->> attachment-types
         (map #(case %
                 :email-attachment-type/invoice-pdf "Rechnung"
                 :email-attachment-type/invoice-appendix-pdf "Anhang"
                 :email-attachment-type/invoice-appendix-excel "Excel"
                 "Unbekannter Anhang"))
         (str/join ", "))]])

(defn has-extra-items? [{:as _billing-template :billing/keys [extra-items]} item-type]
  (some (comp #{item-type} :billing/type) extra-items))

(defn document-type-score [t]
  (if (string? t)
    (cond
      (str/ends-with? t "-Anhang.pdf") 2
      (str/ends-with? t ".pdf") 1
      (str/ends-with? t ".xlsx") 3
      (str/ends-with? t ".csv") 4
      :else 0)
    0))

(defn compare-document-types [x y]
  (compare (document-type-score x) (document-type-score y)))

(defn render-documents [documents]
  [:div.mt-4.mb-8.mx-auto.max-w-4xl.print:hidden [:h4 (tr "Documents")]
   (into [:div.bg-white.rounded-lg.overflow-x-auto.max-w-lg.mx-auto.mt-4.min-w-full.flex.flex-col.gap-3.p-5.shadow-sm]
         (map (fn [{:as document :cas/keys [multihash] file-name :file/name}]
                [:div
                 [ui/link
                  {:href (str "/invoices/document/" multihash)
                   :size 3}
                  [:div.flex.items-center.gap-2
                   (condp #(str/ends-with? %2 %1) file-name
                     ".pdf" icons/pdf
                     ".xlsx" icons/excel
                     ".csv" icons/csv)
                   file-name]]])
              (sort-by :file/name compare-document-types documents)))])

(defn render-downloads [downloads invoice-number]
  (let [form {:invoice-number invoice-number}]
    [:div.mt-4.mb-8.mx-auto.max-w-4xl.print:hidden [:h4 (tr "Downloads")]
     [:div.bg-white.rounded-lg.overflow-x-auto.max-w-lg.mx-auto.mt-4.min-w-full.flex.flex-col.gap-3.p-5.shadow-sm
      [:div.flex.items-center
       [ui/button
        {:variant :white
         :size 3
         :class "rounded-r-none text-indigo-700 border-indigo-300"
         :disabled? true}
        [:div.flex.items-center.gap-2
         icons/document
         (tr "Downloads")]]
       [ui/dropdown
        {:button [ui/button {:size 3 :variant :white :class "rounded-l-none border-l-0 flex items-center px-2"} [ui/icon {:size 16} :chevron-down]]
         :items
         (into [:<>] (map (fn [{:as download :keys [description icon export-type]}]
                            [ui/dropdown-link
                             {:href (str "/" (export-link form export-type))}
                             [ui/icon icon]
                             (tr description)])
                          downloads))}]
       [:div.font-medium.text-gray-500.text-xs.flex.ml-4 (tr "Further export-files as download")]]]]))

(defn recipient-form [title !state kw]
  (when (seq (get @!state kw))
    [:div
     [:div.px-5.py-2.tracking-wider.uppercase.font-bold.text-xs.border-b.leading-none.bg-slate-50.shadow-inner
      title]
     [:div.flex.items-center.px-5.py-3.gap-3
      (into [:ul.mb-4]
            (map (fn [[recipient enabled?]]
                   [:label.flex.items-center.gap-2.py-1
                    {:for (str kw recipient)}
                    [:input {:type :checkbox
                             :id (str kw recipient)
                             :checked enabled?
                             :on-change (fn [event]
                                          (if (.. event -target -checked)
                                            (swap! !state assoc-in [kw recipient] true)
                                            (swap! !state assoc-in [kw recipient] false)))}]
                    recipient]))
            (get @!state kw))]]))

(defn attachment-checkbox [!state email-attachment-type title]
  [:label.flex.items-center.gap-2.py-1
   {:for (str email-attachment-type)}
   [:input {:type :checkbox
            :id (str email-attachment-type)
            :checked (contains? (:attachment-types @!state) email-attachment-type)
            :on-change (fn [event]
                         (if (.. event -target -checked)
                           (swap! !state update :attachment-types conj email-attachment-type)
                           (swap! !state update :attachment-types disj email-attachment-type)))}]
   title])

(defn valid-email-address? [address]
  (re-matches (js/RegExp. "^[A-Z0-9._%+-]+@[A-Z0-9.-]+\\.[A-Z]{2,6}$" "i") (str address)))

(defn select-enabled-keys [vals]
  (keep (fn [[k v]]
          (when v k))
        vals))

(defn state->mail-config [state]
  (-> state
      (update :to select-enabled-keys)
      (update :cc select-enabled-keys)
      (update :bcc select-enabled-keys)))

(defn render-mails [{:as mail-jobs :keys [job-list] {:keys [to cc bcc attachment-types]} :mail-config invoice-number :invoice/invoice-number}]
  [:div.mb-8.mx-auto.max-w-4xl.print:hidden [:h4.mb-4 (tr "Mails")]
   [:div.overflow-hidden.shadow-sm.rounded-lg.mt-4
    [:table.divide-y.divide-gray-200.min-w-full
     [:thead.bg-slate-100.min-w-full
      [:tr
       [:th.px-6.py-3.text-left.text-xs.font-medium.text-gray-500.uppercase.tracking-wider (tr "Empfänger")]
       [:th.px-6.py-3.text-left.text-xs.font-medium.text-gray-500.uppercase.tracking-wider (tr "Attachments")]
       [:th.px-6.py-3.text-right.text-xs.font-medium.text-gray-500.uppercase.tracking-wider (tr "Created")]
       [:th.px-6.py-3.text-right.text-xs.font-medium.text-gray-500.uppercase.tracking-wider (tr "Versendet")]]]
     (if-not (empty? job-list)
       (into [:tbody]
             (map (fn [{:keys [to cc bcc attachment-types] :ductile/keys [created-at] :notification/keys [sent-at kind] :as job-description}]
                    [:tr.odd:bg-white.even:bg-slate-50.border-b.last:border-b-0
                     [:td.text-left.p-4.whitespace-normal.text-sm.max-w-xs
                      [:div.text-xs {:class (if (= :email.ductile/accounting kind)
                                              "text-gray-500 font-medium"
                                              "font-bold")}
                       (str "An: " (str/join ", " to))]
                      (when (seq cc)
                        [:div.font-medium.text-gray-500.text-xs.flex (str "CC: " (str/join ", " cc))])
                      (when (seq bcc)
                        [:div.font-medium.text-gray-500.text-xs.flex (str "BCC: " (str/join ", " bcc))])]

                     [:td.text-left.p-4.whitespace-nowrap.text-xs.text-gray-500
                      [:div.font-medium.text-gray-500.text-xs.flex (if (= :email.ductile/accounting kind)
                                                                     "Diamant Übergabedatei"
                                                                     (->> attachment-types
                                                                          (map #(case %
                                                                                  :email-attachment-type/invoice-pdf "Rechnung"
                                                                                  :email-attachment-type/invoice-appendix-pdf "Anhang"
                                                                                  :email-attachment-type/invoice-appendix-excel "Excel"
                                                                                  :email-attachment-type/invoice-appendix-diamant "Diamant"
                                                                                  "Unbekannter Anhang"))
                                                                          (str/join ", ")))]]
                     [:td.text-right.p-4.whitespace-nowrap.text-xs.text-gray-500
                      [:div.font-medium.text-gray-500.text-xs (time.format/->str {:format :datetime :locale :de} created-at)]]
                     [:td.text-right.p-4.text-xs.text-gray-500
                      [:div.font-bold.text-xs (time.format/->str {:format :datetime :locale :de} sent-at)]]])

                  (sort-by :created-at job-list)))
       [:tbody
        [:tr.border-b
         [:td.p-4.text-center.font-bold.text-gray-500.text-sm {:col-span "4"}
          "Es wurden noch keine Emails versendet"]]])]]
   (let [initial-state {:to (->> to (map #(vec [% true])) (into {}))
                        :cc (->> cc (map #(vec [% true])) (into {}))
                        :bcc (->> bcc (map #(vec [% true])) (into {}))
                        :attachment-types (set attachment-types)}]
     (when-current-user-scope
      :scope/billing
      (r/with-let [!state (r/atom initial-state)
                   !confirmation? (r/atom false)
                   !new-recipient (r/atom nil)
                   !new-recipient-kw (r/atom :to)]
        [:div.bg-white.rounded-lg.shadow-sm.overflow-x-auto.max-w-lg.mx-auto.mt-8.min-w-full
         [:div.px-5.py-2.bg-slate-50.border-b
          [:div.leading-none.justify-between.flex.items-center.gap-4
           [:h2.text-base.font-bold "Rechnung per E-Mail versenden…"]]]
         [:div

          [recipient-form "Empfänger" !state :to]
          [recipient-form "Kopie" !state :cc]
          [recipient-form "Blindkopie" !state :bcc]

          [:div
           [:div.px-5.py-2.tracking-wider.uppercase.font-bold.text-xs.border-b.leading-none.bg-slate-50.shadow-inner
            "Anhänge"]
           [:div.flex.items-center.px-5.py-3.gap-3
            [:ul.mb-4
             [attachment-checkbox !state :email-attachment-type/invoice-pdf "Rechnung"]
             [attachment-checkbox !state :email-attachment-type/invoice-appendix-pdf "Anhang"]
             [attachment-checkbox !state :email-attachment-type/invoice-appendix-excel "Excel"]]]]


          [:div
           [:div.flex.border-b.pb-2]
           [:div.flex.items-center.px-5.py-3.gap-3
            (let [choices [{:ui/value :to :ui/label "Empfänger"}
                           {:ui/value :cc :ui/label "Kopie"}
                           {:ui/value :bcc :ui/label "Blindkopie"}]]
              [combobox/view
               {:placeholder (tr "Select billing month")
                :size 3
                :choices choices
                :value (some #(when (= @!new-recipient-kw (:ui/value %)) %) choices)
                :on-change #(reset! !new-recipient-kw (:ui/value %))}])
            [ui/input {:value @!new-recipient
                       :on-input #(reset! !new-recipient (.. % -target -value))
                       :class (str "flex-auto " (when (and (not (valid-email-address? @!new-recipient))
                                                           (not (str/blank? @!new-recipient)))
                                                  "bg-red-100"))
                       :size 3}]
            [ui/button {:disabled (or (str/blank? (str/trim (str @!new-recipient)))
                                      (not (valid-email-address? @!new-recipient)))
                        :on-click #(do
                                     (swap! !state assoc-in [@!new-recipient-kw @!new-recipient] true)
                                     (reset! !new-recipient ""))
                        :size 3}
             [ui/icon :plus] (tr "Add")]]
           [:div.flex.items-center.px-5.py-4.gap-3.justify-between
            [ui/button {:on-click #(do
                                     (reset! !state initial-state)
                                     (reset! !new-recipient "")
                                     (reset! !new-recipient-kw :to))
                        :variant :destructive-white
                        :size 3}
             (tr "Reset")]
            [ui/button {:on-click #(do (reset! !confirmation? true)
                                       (.preventDefault %))
                        :disabled (-> @!state state->mail-config :to seq not)
                        :variant :primary
                        :size 3}

             [ui/icon :paper-plane] (tr "Send")]]]]
         (when @!confirmation?
           [:div.fixed.inset-0.flex.items-center.justify-center.z-50.confirm-dialog
            [:div {:class "relative px-4 min-h-screen md:flex md:items-center md:justify-center"}
             [:div.opacity-25.w-full.h-full.absolute.z-10.inset-0]
             [:div {:class "bg-white rounded-lg md:max-w-md md:mx-auto p-4 fixed inset-x-0 bottom-0 z-50 mb-4 mx-4 md:relative shadow-lg"}
              [:div {:class "md:flex items-center"}
               [:div.rounded-full.border.border-gray-300.flex.items-center.justify-center.w-16.h-16.flex-shrink-0.mx-auto
                [:i.bx.bx-error.text-3xl icons/contract]]
               [:div {:class "mt-4 md:mt-0 md:ml-6 text-center md:text-left"}
                [:b "E-Mail versenden?"]
                [email-sending-details (state->mail-config @!state)]]]



              [:div {:class "text-center md:text-right mt-4 md:flex md:justify-end"}
               [ui/button {:size 3
                           :on-click #(do (reset! !confirmation? false)
                                          (.preventDefault %))}
                (tr "Cancel")]
               [ui/button {:variant :primary
                           :size 3
                           :type "submit" :class "ml-4"
                           :on-click (fn [event]
                                       (reset! !confirmation? false)
                                       (.preventDefault event)
                                       (deframe/call-lambda 'ductile.billing/$send-mail! {:invoice-number invoice-number
                                                                                          :mail-config (state->mail-config @!state)}))}

                [ui/icon :paper-plane] (tr "Send")]]]]])])))])


(defn billing-errors-group-item [[group-name group-items]]
  (r/with-let [!expanded? (r/atom false)]
    [:div.border-b.last:border-b-0
     [:div.flex.gap-2.px-5.py-3.hover:text-indigo-600.group.cursor-pointer
      {:on-click #(swap! !expanded? not)
       :class (when-not @!expanded? "hover:bg-indigo-50")}
      [:div.flex.gap-2
       [ui/icon {:size 20 :class (str "mt-[4px] transition " (when @!expanded? "rotate-90"))} :chevron-right]]
      [:div.flex.items-center.gap-2.flex-auto
       [:div.text-sm group-name]]
      [:div [ui/badge
             {:variant :gray}
             (count group-items)]]]
     (when @!expanded?
       (into [:div.mx-5.mb-3.flex.flex-col.gap-2]
             (map (fn [{:as billing-error :keys [message]}]
                    [:div.text-xs.bg-slate-100.rounded.px-3.py-2.flex.flex-col.gap-1
                     [:div.flex.items-center.gap-3
                      [:div.flex.items-center.gap-1
                       [ui/icon {:size 12} :car]
                       message]]]))
             group-items))]))

(defscene billing-errors-card []
  [billing-errors-group-item ["Billing" []]])

(defn render-billing-errors [errors]
  [:div.my-8.mx-auto.max-w-4xl.print:hidden [:h4.mb-4 (str "🛑 " (count errors) " " (tr "Errors"))]
   (->> errors
        (group-by #(or (:group-by %) (:message %)))
        (sort-by (comp count val) >=)
        (map (fn [e] [billing-errors-group-item e]))
        (into [:div]))])

(defn render-billing-warnings [warnings]
  [:div.my-8.mx-auto.max-w-4xl.print:hidden [:h4.mb-4 (str "⚠️ " (count warnings) " " (tr "Warnings"))]
   (->> warnings
        (group-by #(or (:group-by %) (:message %)))
        (sort-by (comp count val) >=)
        (map (fn [e] [billing-errors-group-item e]))
        (into [:div]))])


(declare cancel-causes)


(defn render-storno-info [{:as data :invoice/keys [cancel-cause cancel-message]}]
  (if-let [{:as canceled-invoice-info canceled-invoice-number :invoice/invoice-number invoice-type :invoice/type} (:credit-note/canceled-invoice data)]
    [:div.mb-8.mx-auto.max-w-4xl.print:hidden [:h4.mb-4 (tr "Storno für")]
     [:div
      [:a {:href (str "/invoice/" canceled-invoice-number)}
       (str (condp = invoice-type
              :invoice.type/invoice "🧾 Rechnung"
              :invoice.type/payment "🚛️ Gutschrift"   ;; Unternehmer- / Transport Gutschrift
              "*️⃣ Unbekannt") " " canceled-invoice-number)]
      (when-current-user-scope
       :scope/billing
       (let [url-params (-> canceled-invoice-info
                            (select-keys [:contract-ids :template-id :billing-year-month :accounting-year-month :invoice-types :compound-ids])
                            (update :contract-ids (comp pr-str set))
                            (update :compound-ids (comp pr-str set))
                            (update :template-id str))]

         [:span.ml-4
          [ui/button {:href (str "/billing?" (util/map->url-encoded-query-params url-params)) :target "_blank"}
           "Neu abrechnen"]]))
      (when cancel-cause
        [:div.my-8.mx-auto.max-w-4xl.print:hidden
         [:div.text-sm.mt-2 (str "Stornierungsgrund: " (tr cancel-cause))]
         (when-not (str/blank? cancel-message)
           [:div.text-sm.mt-2 (str "Begründung: " cancel-message)])])]]
    (when-let [{canceling-invoice-number :invoice/invoice-number cancel-data :invoice/billing-date :invoice/keys [cancel-cause cancel-message]} (:credit-note/_canceled-invoice data)]
      [:div.mb-8.mx-auto.max-w-4xl.print:hidden [:h4.mb-4 (str (tr "Storniert am ") (time.format/->str {:format :date :style :short :locale :de} cancel-data))]
       [:div [:a {:href (str "/invoice/" canceling-invoice-number)}
              (str "↩️ Stornorechnung " canceling-invoice-number)]]
       [:div.text-sm.mt-2 (str "Stornierungsgrund: " (tr cancel-cause))]
       (when-not (str/blank? cancel-message)
         [:div.text-sm.mt-2 (str "Begründung: " cancel-message)])])))

(def cancel-causes
  [:invoice.cancel-cause/formally-incorrect
   :invoice.cancel-cause/contract-expired
   :invoice.cancel-cause/prices-outdated
   :invoice.cancel-cause/incorrect-billing-address
   :invoice.cancel-cause/incorrect-billing-items])


(defn cancel-confirmation [{:as data :keys [invoice-number on-cancel !generating-cancellation?]} !confirmation? accounting-deadline-day]
  (r/with-let [?send-email? false]
    (with-form [!form {:accounting-year-month ?accounting-year-month
                       :invoice-number ?invoice-number
                       :cancel-cause ?cancel-cause
                       :cancel-message ?cancel-message
                       :send-email? ?send-email?}
                :init {?accounting-year-month (set-default-accounting-year-month accounting-deadline-day)
                       ?invoice-number invoice-number
                       ?send-email? false}
                :required [?accounting-year-month ?cancel-cause]]
      [:div.fixed.inset-0.flex.items-center.justify-center.z-50.confirm-dialog
       [:div {:class "relative px-4 min-h-screen md:flex md:items-center md:justify-center"}
        [:div.opacity-25.w-full.h-full.absolute.z-10.inset-0]
        [:div {:class "bg-white rounded-lg md:max-w-md md:mx-auto p-4 fixed inset-x-0 bottom-0 z-50 mb-4 mx-4 md:relative shadow-lg"}
         [:div {:class "md:flex items-center"}
          [:div.rounded-full.border.border-gray-300.flex.items-center.justify-center.w-16.h-16.flex-shrink-0.mx-auto
           [:i.bx.bx-error.text-3xl icons/contract]]
          [:div {:class "mt-4 md:mt-0 md:ml-6 text-center md:text-left"}
           [:b (tr "Cancel invoice") "?"]
           [:p.text-sm.text-gray-700.mt-1 (tr "Are you sure to cancel this invoice?")]
           [:div
            [:div.uppercase.tracking-wide.text-xs.mb-2.mt-6.font-medium
             (tr "Accounting month")]
            [:div
             (let [current-month (.getMonth (js/Date.))
                   month-names [(tr "January") (tr "February") (tr "March") (tr "April")
                                (tr "May") (tr "June") (tr "July") (tr "August")
                                (tr "September") (tr "October") (tr "November") (tr "December")]
                   choices (reverse (map #(let [billing-month (js/Date.)
                                                _ (.setMonth billing-month %)
                                                month (+ 1 (.getMonth billing-month))
                                                month-name (get month-names (.getMonth billing-month))
                                                month (if (<= 10 month) (str month) (str "0" month))
                                                year (.getFullYear billing-month)]
                                            {:ui/value (str year "-" month) :ui/label (str month-name " " year)})
                                         (range (- current-month 12) (inc current-month))))]
               [combobox/view
                {:placeholder (tr "Select accounting month")
                 :size 3
                 :choices choices
                 :value (some #(when (= @?accounting-year-month (:ui/value %)) %) choices)
                 :on-change #(reset! ?accounting-year-month (:ui/value %))}])]]
           [:p.text-xs.text-gray-500.mt-1 (str (tr "Accounting deadline:") " " accounting-deadline-day (tr "th"))]
           [:div.mb-4
            [:div.uppercase.tracking-wide.text-xs.mb-2.mt-6.font-medium
             (tr "Reason for cancellation")]
            [:div
             (let [choices (mapv (fn [cause] {:ui/value (str cause) :ui/label (tr cause)}) cancel-causes)]
               [combobox/view
                {:placeholder (tr "Select cancel reason")
                 :size 3
                 :choices choices
                 :value (some #(when (= (str @?cancel-cause) (str (:ui/value %))) %) choices)
                 :on-change #(reset! ?cancel-cause (:ui/value %))}])]]
           [:label.block.mb-2.uppercase.tracking-wide.text-xs.font-medium
            {:for "cancel-message"}
            (tr "Explanation")]
           [:textarea.w-full.text-sm.text-gray-900.bg-gray-50.rounded-lg.border.border-gray-300.block.p-2.focus:ring-blue-500.focus:border-blue-500.dark:bg-gray-700
            {:id "cancel-message"
             :rows "4"
             :placeholder (tr "Please enter explanation here, why the invoice was cancelled.")
             :on-change (fn [e]
                          (reset! ?cancel-message (.-value (.-target e))))}]
           #_(when-let [email-config (:billing-template/email-config (some #(when (= @?template-id (:ductile/id %)) %)
                                                                           (mapcat :contract/billing-templates contracts)))]
               [:div
                [:p.text-sm.text-gray-700.mt-4 "E-Mail an Rechnungsempfänger senden?"]
                [email-sending-details email-config]
                [:label.flex.items-center.gap-2.py-1.text-sm.text-gray-700
                 {:for "send-email-checkbox"}
                 [:input {:type :checkbox
                          :id "send-email-checkbox"
                          :checked @?send-email?
                          :on-change (fn [event]
                                       (if (.. event -target -checked)
                                         (reset! ?send-email? true)
                                         (reset! ?send-email? false)))}]
                 "E-Mails versenden?"]])]]

         [:div {:class "text-center md:text-right mt-4 md:flex md:justify-end"}
          [ui/button {:size 3
                      :on-click #(do (reset! !confirmation? false)
                                     (reset! ?send-email? false)
                                     (.preventDefault %))}
           (tr "Cancel")]
          [ui/button {:variant :primary
                      :size 3
                      :type "submit" :class "ml-4 bg-red-600 hover:bg-red-800 disabled:bg-red-200"
                      :disabled (not @?cancel-cause)
                      :on-click (fn [event]
                                  (.preventDefault event)
                                  (forms/try-submit+
                                   !form
                                   (when on-cancel
                                     (reset! !confirmation? false)
                                     (reset! !generating-cancellation? true)
                                     (on-cancel @!form))))}
           (tr "Cancel Invoice & Save")]]]]])))


(defn cancel-invoice-button [{:as data :keys [!invoice-cancellation-result billing-errors billing-warnings !generating-cancellation?]} !confirmation?]
  [:div.flex.items-center
   [ui/button {:on-click #(do (reset! !confirmation? true)
                              (.preventDefault %))
               :variant (cond (and (seq billing-warnings) (not (seq billing-errors))) :destructive
                              (= :succeeded @!invoice-cancellation-result) :white
                              :else :destructive-white)
               :loading? @!generating-cancellation?
               :disabled? (or (= :succeeded @!invoice-cancellation-result)
                              @!generating-cancellation?)}


    (cond-> (cond
              (= :succeeded @!invoice-cancellation-result)
              (tr "Canceled invoice")
              @!generating-cancellation?
              (str (tr "Cancelling invoice") "…")
              :else
              (tr "Cancel invoice"))
      (seq billing-warnings)
      (str " ⚠️"))]
   (when (= :succeeded @!invoice-cancellation-result)
     [:div.ml-4 icons/check])])


(defn render-preview [{:as data :keys [invoices unbilled-services double-billed-services unbilled-storage accounting-summary credit-note-invoice-id cancellation-error cancellation-warning
                                       invoice services-items accessory-services-items storage-items accessory-storage-items storage-by-day transport-items load-items accounting-items billing-error billing-warning billing-errors billing-warnings saved-invoice-id documents downloads mail-jobs invoice-number]
                       invoice-type :invoice/type}]
  (r/with-let [!confirm-cancellation? (r/atom false)]
    [:div.pt-10
     (cond
       billing-error
       [render-billing-error billing-error]
       saved-invoice-id
       [render-billing-success saved-invoice-id billing-warning])
     (when (seq billing-errors)
       [render-billing-errors billing-errors])
     (when (seq billing-warnings)
       [render-billing-warnings billing-warnings])
     (if invoices
       [:div.my-8.mx-auto.max-w-6xl.print:max-w-none.min-h-a4.print-margin
        [:h4.mb-4.page-break-avoid (tr "Invoices")]
        [render/inspect (viewer/with-viewer (:name viewer/table-viewer) {:nextjournal.clerk/page-size nil} invoices)]]
       [ui/tabs {:default-value :invoice}
        [:div.flex.items-center.justify-end.mb-3.text-xs.w-full.max-w-4xl.mx-auto.print:hidden
         [ui/tabs-list
          [ui/tab {:value :invoice} [:b "Rechnungsansicht"]]
          [ui/tab {:value :accounting} "Buchhaltungsansicht"]]]
        [ui/tab-content {:value :invoice :class "py-2 print:p-0 print-margin min-h-a4"}
         [:div invoice
          (when @!confirm-cancellation?
            [cancel-confirmation data !confirm-cancellation? 20])]]
        [ui/tab-content {:value :accounting :class "py-2 print:p-0 print-margin min-h-a4"}
         accounting-summary]
        [:div.flex.items-center.justify-between.mb-3.text-xs.w-full.max-w-4xl.mx-auto.print:hidden
         (when (and (not (:credit-note/canceled-invoice data))
                    (not (:credit-note/_canceled-invoice data))
                    (#{:invoice.type/invoice} invoice-type)
                    documents)
           (when-current-user-scope
            :scope/billing
            [:div.flex.items-center.justify-start.mt-3.mb-3.text-xs.w-full.max-w-4xl.mx-auto.print:hidden
             [cancel-invoice-button data !confirm-cancellation?]]))]])

     (when cancellation-error
       [render-cancellation-error cancellation-error])
     (when credit-note-invoice-id
       [render-cancellation-success credit-note-invoice-id cancellation-warning])
     [render-storno-info data]
     (when documents
       (render-documents documents))
     (when (and (seq downloads) invoice-number)
       (render-downloads downloads invoice-number))
     (when mail-jobs
       (render-mails mail-jobs))
     (when (seq (:rows accounting-items))
       [:div.mb-8.mx-auto.max-w-full.print:hidden
        [:h4.mb-4 (tr "Accounting items")]
        [render/inspect (viewer/table accounting-items)]])
     (when (seq (:rows services-items))
       [:div.mb-8.mx-auto.max-w-6xl.print:max-w-none.min-h-a4.print-margin.print:hidden
        [:h4.mb-4.page-break-avoid (tr "Service items")]
        [render/inspect (viewer/with-viewer (:name viewer/table-viewer) {:nextjournal.clerk/page-size nil} services-items)]])

     (when (seq (:rows accessory-services-items))
       [:div.mb-8.mx-auto.max-w-6xl.print:max-w-none.min-h-a4.print-margin.print:hidden
        [:h4.mb-4.page-break-avoid (tr "Accessory Service items")]
        [render/inspect (viewer/with-viewer (:name viewer/table-viewer) {:nextjournal.clerk/page-size nil} accessory-services-items)]])

     (when (seq (:rows storage-by-day))
       [:div.mb-8.mx-auto.max-w-6xl.print:max-w-none.min-h-a4.print-margin.print:hidden
        [:h4.mb-4.page-break-avoid (tr "Daily Overview")]
        [render/inspect (viewer/with-viewer (:name viewer/table-viewer) {:nextjournal.clerk/page-size nil} storage-by-day)]])

     (when (seq (:rows storage-items))
       [:div.mb-8.mx-auto.max-w-6xl.print:max-w-none.min-h-a4.print-margin.print:hidden
        [:h4.mb-4.page-break-avoid (tr "Storage items")]
        [render/inspect (viewer/with-viewer (:name viewer/table-viewer) {:nextjournal.clerk/page-size nil} storage-items)]])

     (when (seq (:rows accessory-storage-items))
       [:div.mb-8.mx-auto.max-w-6xl.print:max-w-none.min-h-a4.print-margin.print:hidden
        [:h4.mb-4.page-break-avoid (tr "Accessory Storage")]
        [render/inspect (viewer/with-viewer (:name viewer/table-viewer) {:nextjournal.clerk/page-size nil} accessory-storage-items)]])

     (when (seq (:rows transport-items))
       [:div.mb-8.mx-auto.max-w-8xl.print:max-w-none.min-h-a4.print-margin.print:hidden
        [:h4.mb-4.page-break-avoid (tr "Transports")]
        [render/inspect (viewer/with-viewer (:name viewer/table-viewer) {:nextjournal.clerk/page-size nil} transport-items)]])

     (when (seq (:rows load-items))
       [:div.mb-8.mx-auto.max-w-8xl.print:max-w-none.min-h-a4.print-margin.a4-landscape
        [:h4.mb-4.page-break-avoid (tr "Loads")]
        [render/inspect (viewer/with-viewer (:name viewer/table-viewer) {:nextjournal.clerk/page-size nil} load-items)]])

     (when (seq (:rows unbilled-services))
       [:div.mb-8.mx-auto.max-w-8xl.print:max-w-none.min-h-a4.print-margin
        [:h4.mb-4.page-break-avoid (str "⚠️ " (tr "Unbilled Services"))]
        [render/inspect (viewer/with-viewer (:name viewer/table-viewer) {:nextjournal.clerk/page-size nil} unbilled-services)]])

     (when (seq (:rows double-billed-services))
       [:div.mb-8.mx-auto.max-w-8xl.print:max-w-none.min-h-a4.print-margin
        [:h4.mb-4.page-break-avoid (str "⚠️ " (tr "Double Billed Services"))]
        [render/inspect (viewer/with-viewer (:name viewer/table-viewer) {:nextjournal.clerk/page-size nil} double-billed-services)]])

     (when (seq (:rows unbilled-storage))
       [:div.mb-8.mx-auto.max-w-4xl.print:max-w-none.min-h-a4.print-margin
        [:h4.mb-4.page-break-avoid (str "⚠️ " (tr "Unbilled Storage"))]
        [render/inspect (viewer/with-viewer (:name viewer/table-viewer) {:nextjournal.clerk/page-size nil} unbilled-storage)]])]))


(defn render-preview-form [form-map {:as match :keys [query-params]}]
  (let [{:as state} @(deframe/!get-in [])
        compound-name @deframe/!current-compound
        invoice-result (-> state :current-route/transient :result)
        succeeded? (:saved-invoice-id invoice-result)
        update-url!
        (fn [params]
          (.pushState js/window.history nil nil
                      (str "?" (util/map->url-encoded-query-params
                                (cond-> params
                                  (:template params)
                                  (assoc :template-id #(when % (with-out-str (prn (-> params :template :ductile/id)))))
                                  (:contract params)
                                  (assoc :contract-id #(when % (with-out-str (prn (-> params :contract :ductile/id)))))
                                  true
                                  (dissoc :file-upload))))))]
    [:div.p-5.print:p-0
     [workflow/form form-map]



     (let [form-state (get-in state (vec (concat [:current-route/transient] (workflow/form-path form-map))))
           {:keys [contract-ids template-id] :as form}
           (-> form-state
               ((:form/transform-fn form-map) form-map)
               (select-keys [:contract-ids :template-id :invoice-types :truck-id :accounting-year-month :compound-ids :contract-name :billing-year-month :compound-names]))
           billing-errors (:billing-errors invoice-result)]

       [:div.flex.items-center.bg-slate-100.justify-between.p-3.max-w-2xl.mx-auto.rounded-lg.border.border-gray-200.mt-3
        [:div.flex.gap-2
         [:div.flex.items-center
          [ui/button
           {:size 4
            :variant :white
            :href (export-link form "xlsx")
            :class "rounded-r-none"}
           [:div.flex.items-center.gap-2
            icons/excel
            (tr "Download")]]
          [ui/dropdown
           {:button [ui/button {:size 4
                                :variant :white
                                :class "rounded-l-none border-l-0 flex items-center px-2"} [ui/icon {:size 16} :chevron-down]]
            :items (if template-id
                     [:<>
                      [ui/dropdown-link
                       {:href (export-link form "pdf")}
                       [ui/icon :pdf]
                       (tr "Download PDF Invoice")]
                      [ui/dropdown-link
                       {:href (export-link form "pdf-items")}
                       [ui/icon :pdf]
                       (tr "Download PDF Items")]
                      [ui/dropdown-link
                       {:href (export-link form "xlsx")}
                       [ui/icon :excel]
                       (tr "Download Excel")]
                      [ui/dropdown-link
                       {:href (export-link form "services-csv")}
                       [ui/icon :csv]
                       (tr "Download Services CSV")]
                      [ui/dropdown-link
                       {:href (export-link form "transports-csv")}
                       [ui/icon :csv]
                       (tr "Download Loads CSV")]
                      [ui/dropdown-link
                       {:href (export-link form "zweite-bereitstellung-excel")}
                       [ui/icon :excel]
                       (tr "Download 2. Bereitstellung Radsatz Excel")]
                      [ui/dropdown-link
                       {:href (export-link form "storage-csv")}
                       [ui/icon :csv]
                       (tr "Download Storage CSV")]
                      [ui/dropdown-link
                       {:href (export-link form "diamant")}
                       [ui/icon :csv]
                       (tr "Download Diamant CSV")]
                      [ui/dropdown-link
                       {:href (export-link form "charged-elog-services")}
                       [ui/icon :excel]
                       (tr "Billed ELOG services")]]

                     [:<>
                      [ui/dropdown-link
                       {:href (export-link form "xlsx")}
                       [ui/icon :excel]
                       (tr "Download Excel with unbilled items")]
                      [ui/dropdown-link
                       {:href (export-link form "unbilled-amounts")}
                       [ui/icon :csv]
                       (tr "Download CSV with open amounts")]])}]]]

        [:div.flex.items-center
         [ui/button {:variant (if succeeded? :white :primary)
                     :on-click (fn []
                                 (update-url! form)
                                 (ui/show-form-modal! 'ductile.billing/confirm-form form))
                     :size 4
                     :disabled? (or (not contract-ids)
                                    (seq billing-errors)
                                    succeeded?
                                    (not (:template form-state))
                                    (when-let [billing-template (:template form-state)]
                                      (or (= :internal-costs (:billing-template/template-type billing-template))
                                          (:billing/create-invoice-disabled? billing-template))))}
          (cond
            succeeded?
            (tr "Created invoice")
            :else
            (tr "Create invoice"))]]])


     (when invoice-result
       [render-preview invoice-result])]))


(defn step-header [step text]
  [:h2.flex.items-center.mb-12
   [:div.rounded-full.text-md.font-bold.flex.justify-center.items-center.border-2.border-green-700.w-8.h-8 step]
   [:span.text-2xl.font-bold.ml-3 text]])

(defn todos [items]
  [:<>
   [:h3.mb-4.text-xl.font-bold "🚧 Todos"]
   (into [:ul.mb-4]
         (map (fn [{:keys [label checked?]}]
                [:div.flex.items-center
                 [:input {:type "checkbox"
                          :default-checked checked?
                          :class "mr-2 h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"}]
                 [:label.text-lg label]])
              items))])

(defn todo-mark []
  [:span.text-red-500.text-xs.bg-red-100.rounded.px-1.font-normal
   {:style {:padding-top 2 :padding-bottom 2}}
   "TODO"])

(defscene story
  [:div.p-8
   [:div.p-2
    [:h1.text-3xl.mb-12.font-bold "Rechnungslegung"]
    [step-header 1 "Abrechenbare Dienstleistungen"]
    [:div.flex
     [:div
      {:class "w-1/2 mr-8"}
      [:h3.text-xl.mb-4.font-bold "Übersicht"]
      [:p.text-lg.mb-4
       "Die Übersicht Rechnungsbildung hat 2 primäre Funktionen: das Auffinden fehlerhafter Datensätze sowie die
       Rechnungserstellung aus abrechenbaren Dienstleistungen."]
      [:h3.text-xl.mb-4.font-bold.flex.items-center [:span.mr-2 "Filter "] [todo-mark]]
      [:p.text-lg.mb-4
       "Die Filtergruppe links dient zum Eingrenzen der Datensätze nach Dienstleistung, Zeitraum,
       Abrechnungsart, usw. Ggf. können bestimmte Dienstleistungen (z.B. Transport) zusätzliche Filtermöglichkeiten
       (z.B. Strecke) einblenden."]
      [todos [{:label "Dienstleistungen Filter sollte Mehrfachauswahl erlauben"}
              {:label "Filteroptionen je nach ausgewählten Dienstleistungen"}
              {:label "Ansichten zur Fehlerbehebung"}]]]
     [:div
      {:class "w-1/2 ml-8"}
      [:h3.text-xl.mb-4.font-bold.flex.items-center [:span.mr-2 "Fehlerdetails "] [todo-mark]]
      [:p.text-lg.mb-4
       "Je nach Auswahl nicht abrechenbarer Dienstleistungen zeigt die Gruppe \"Fehlerdetails\"
       genauere Informationen zu den fehlenden Datensätzen an. Die jeweiligen Details verlinken
       direkt zur Fehlerbehebung."]
      [:h3.text-xl.mb-4.font-bold.flex.items-center [:span.mr-2 "Abrechenbare Dienstleistungen "] [todo-mark]]
      [:p.text-lg.mb-4
       "Unter der Liste fehlerhafter Datensätze finden sich alle abrechenbaren Dienstleistungen je nach ausgewählten
       Filtern. Per Häkchen wird direkt ausgewählt welche Dienstleistungen auf die zu erstellende Rechnung kommen sollen."]]]]
   [:div.mb-12
    [billings-table]]
   [:div.p-2
    [step-header 1 [:div.flex.items-center
                    [:span.mr-2 "Rechnungsvorschau"]
                    [todo-mark]]]
    [:div.flex
     [:div {:class "w-1/2 mr-8"}
      [:h3.text-xl.mb-4.font-bold "Übersicht"]
      [:p.text-lg.mb-4
       "Sobald eine Rechnung erstellt wurde findet man sich in der Rechnungsvorschau. Hier gibt es die Möglichkeiten
       die Rechnung direkt per Email zu versenden, eine PDF-Version davon herunterzuladen oder ggf. noch Rechnungsdetails
       zu bearbeiten. "]]
     [:div {:class "w-1/2 ml-8"}
      [todos [{:label "Option \"PDF Download\" hinzufügen" :checked? true}
              {:label "Option \"Rechnung als Email versenden\" hinzufügen" :checked? true}
              {:label "einzelne Rechnungspositionen bearbeitbar machen"}
              {:label "Ansicht für Rechnungsanhänge implementieren"}]]]]]])

(defn list-fuel-prices [{:as fuel-prices :keys [head rows]} _match]
  [:div
   [:div.mb-4.flex.items-center.justify-between
    [:h2.text-2xl.mx-2 (tr "Fuel Prices")]
    [ui/button
     {:variant :primary
      :href (router/path '[fuel-prices new])}
     [ui/icon :plus]
     (tr "Add fuel prices")]]
   [ui/table+
    [ui/table-header
     (into [ui/table-row]
           (map (comp ui/table-header-cell tr)) head)]
    (into [ui/table-body]
          (map (fn [fp]
                 (into
                  [ui/table-row
                   [ui/table-cell
                    [ui/link
                     {:href (router/path '[fuel-prices :year-month edit]
                                         {:year-month (first fp)})}
                     (first fp)]]]
                  (map (comp ui/table-cell
                             (partial locale/format-number {:minimumFractionDigits 2
                                                            :maximumFractionDigits 10}))) (next fp))))
          rows)]])
